export const iconFontAwesomeShapesCubesStacked = (
	<i className="fa-solid fa-cubes-stacked"></i>
);
